<app-custom-bundle-form
  action="{{ 'new' | translate }}"
  (close)="close($event)">
</app-custom-bundle-form>
